module.exports = __webpack_public_path__ + "img/care.2cb4c1e9.png";